import { extend, getParent, formattedNumber } from '../../furillo/modules/helpers.js';
export default class FundraiserVisualization {

    constructor(element, options) {

        const defaults = {            
            autoInit: true
        };

        this._element = element;        
        this._options = extend(defaults, options);
        this._animationBegin = false;
        this._animationBeginTimestamp;

        if (this._options.autoInit)
            this.init();
    }

    // For case "rectangle" point1 is top left and point2 is bottom right
    _figures = [
        {
            figureId: 'figure-1',
            fillColor: '0,0,0',
            active: false,
            geometries: [
                {
                    type: 'rectangle',
                    point1: { x: 185, y: 746 },
                    point2: { x: 290, y: 1260 },
                    point3: { x: 290, y: 1260 },
                    offset: 0,
                    label: {
                        show: true,
                        value: 0
                    }
                },
                {
                    type: 'rectangle',
                    point1: { x: 1710, y: 746 },
                    point2: { x: 1815, y: 1260 },
                    point3: { x: 1815, y: 1260 },
                    offset: 0,
                    label: {
                        show: true,
                        value: 0
                    }
                }
            ]
        },
        {
            figureId: 'figure-2',
            fillColor: '0,0,0',
            active: false,
            geometries: [
                {
                    type: 'rectangle',
                    point1: { x: 312, y: 435 },
                    point2: { x: 563, y: 1555 },
                    point3: { x: 563, y: 1555 },
                    offset: 5,                    
                    label: {
                        show: true,
                        value: 0
                    }
                },
                {
                    type: 'rectangle',
                    point1: { x: 1437, y: 435 },
                    point2: { x: 1688, y: 1555 },
                    point3: { x: 1688, y: 1555 },
                    offset: 5,                    
                    label: {
                        show: true,
                        value: 0
                    }
                }
            ]
        },
        {
            figureId: 'figure-3',
            fillColor: '0,0,0',
            active: false,
            geometries: [
                {
                    type: 'rectangle',
                    point1: { x: 600, y: 645 },
                    point2: { x: 795, y: 1260 },
                    point3: { x: 795, y: 1260 },
                    offset: 100,                    
                    label: {
                        show: true,
                        value: 0
                    }
                },
                {
                    type: 'rectangle',
                    point1: { x: 1205, y: 645 },
                    point2: { x: 1400, y: 1260 },
                    point3: { x: 1400, y: 1260 },
                    offset: 100,                    
                    label: {
                        show: true,
                        value: 0
                    }
                }
            ]
        },
        {
            figureId: 'figure-4',
            fillColor: '0,0,0',
            active: false,
            geometries: [
                {
                    type: 'rectangle',
                    point1: { x: 812, y: 745 },
                    point2: { x: 1188, y: 1124 },
                    point3: { x: 1188, y: 1124 },
                    offset: 0,
                    label: {
                        show: true,
                        value: 0
                    }
                }
            ]
        },
        {
            figureId: 'figure-5',
            fillColor: '0,0,0',
            active: false,
            geometries: [
                {
                    type: 'rectangle',
                    point1: { x: 660, y: 1440 },
                    point2: { x: 766, y: 1650 },
                    point3: { x: 766, y: 1650 },
                    offset: 30,
                    label: {
                        show: false,
                        value: 0
                    }
                },
                {
                    type: 'rectangle',
                    point1: { x: 767, y: 1457 },
                    point2: { x: 895, y: 1577 },
                    point3: { x: 895, y: 1577 },
                    offset: 0,
                    label: {
                        show: false,
                        value: 0
                    }
                },
                {
                    type: 'rectangle',
                    point1: { x: 915, y: 1363 },
                    point2: { x: 1083, y: 1690 },
                    point3: { x: 1083, y: 1690 },
                    offset: 20,
                    label: {
                        show: true,
                        value: 0
                    }
                },
                {
                    type: 'rectangle',
                    point1: { x: 1104, y: 1457 },
                    point2: { x: 1232, y: 1577 },
                    point3: { x: 1232, y: 1577 },
                    offset: 0,
                    label: {
                        show: false,
                        value: 0
                    }
                },
                {
                    type: 'rectangle',
                    point1: { x: 1234, y: 1440 },
                    point2: { x: 1339, y: 1650 },
                    point3: { x: 1339, y: 1650 },
                    offset: 30,
                    label: {
                        show: false,
                        value: 0
                    }
                }
            ]
        }
    ];

    draw(timestamp) {
        const base = this;
        
        // Total animation length in ms — change this to whatever you want.
        const ANIMATION_DURATION = 3000;

        // Optional easing so it doesn't feel too linear/mechanical.
        const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);

        const drawFigure = function(figure, t) { 

            const opacity = figure.active ? '.8' : '.9';
            const fillStyle = 'rgba(' + figure.fillColor + ', ' + opacity + ')';
            const strokeStyle = 'rgb(0,0,0)';
            const strokeWeight = 1;

            if (base._canvasLayers[1].context.fillStyle !== fillStyle)
                base._canvasLayers[1].context.fillStyle = fillStyle; 
                
            if (base._canvasLayers[3].context.fillStyle !== fillStyle)
                base._canvasLayers[3].context.fillStyle = fillStyle; 

            for (var i = 0; i < figure.geometries.length; i++) {
                let geometry = figure.geometries[i];

                // Snapshot the starting Y once, and only for geometries that
                // actually need to move (point2.y is above the target).
                if (geometry._startY === undefined) {
                    geometry._startY = geometry.point2.y;
                }
 
                if (geometry._startY > geometry.point3.y) {
                    geometry.point2.y = geometry._startY + (geometry.point3.y - geometry._startY) * t;
                }

                if (base._canvasLayers[1].context.strokeStyle !== strokeStyle)
                    base._canvasLayers[1].context.strokeStyle = strokeStyle;

                if (base._canvasLayers[1].context.lineWidth !== strokeWeight)
                    base._canvasLayers[1].context.lineWidth = strokeWeight;

                base._canvasLayers[1].context.beginPath();
                base._canvasLayers[1].context.moveTo(geometry.point1.x, geometry.point1.y);
                base._canvasLayers[1].context.lineTo(geometry.point2.x, geometry.point1.y);
                base._canvasLayers[1].context.lineTo(geometry.point2.x, geometry.point2.y);
                base._canvasLayers[1].context.lineTo(geometry.point1.x, geometry.point2.y);
                base._canvasLayers[1].context.lineTo(geometry.point1.x, geometry.point1.y);
                base._canvasLayers[1].context.fill();
                base._canvasLayers[1].context.stroke();
                base._canvasLayers[1].context.closePath();
                
                base._canvasLayers[1].context.strokeStyle = 'rgb(245,245,245)';
                base._canvasLayers[1].context.lineWidth = 2;

                base._canvasLayers[1].context.beginPath();                
                base._canvasLayers[1].context.moveTo(geometry.point1.x, geometry.point2.y);
                base._canvasLayers[1].context.lineTo(geometry.point2.x, geometry.point2.y);
                base._canvasLayers[1].context.fill();
                base._canvasLayers[1].context.stroke();
                base._canvasLayers[1].context.closePath();

                // Draw label
                if (!geometry.label.show) continue;
                
                const labelOffset = (30 * base._resizeFactor);
                const labelPoint = { x: geometry.point2.x - ((geometry.point2.x - geometry.point1.x) / 2), y: geometry.point2.y - labelOffset };

                base._canvasLayers[3].context.save();
                base._canvasLayers[3].context.font = 'bold 22px "DM Sans", sans-serif, arial';
                base._canvasLayers[3].context.textBaseline = 'middle';
                base._canvasLayers[3].context.textAlign = 'center';
                
                const textHeight = 22;
                // t already runs 0 -> 1 over the fixed duration, so the counted-up
                // number can just be t * final value — no more shift/ratio math needed.
                const text = formattedNumber(t * geometry.label.value, 0) + '%';
                const padding = 18 * base._resizeFactor;
                
                labelPoint.y -= (textHeight / 2);

                var textWidth = base._canvasLayers[3].context.measureText(text).width;

                base._canvasLayers[3].context.fillStyle = 'rgb(245, 245, 245)';

                base._canvasLayers[3].context.beginPath();
                base._canvasLayers[3].context.moveTo(labelPoint.x - (20 * base._resizeFactor), labelPoint.y + labelOffset);
                base._canvasLayers[3].context.lineTo(labelPoint.x + (20 * base._resizeFactor), labelPoint.y + labelOffset);
                base._canvasLayers[3].context.lineTo(labelPoint.x, labelPoint.y + labelOffset + (textHeight / 2));
                base._canvasLayers[3].context.lineTo(labelPoint.x - (20 * base._resizeFactor), labelPoint.y + labelOffset);
                base._canvasLayers[3].context.fill();                
                base._canvasLayers[3].context.closePath();

                geometry.label.rect = { x: (labelPoint.x - (textWidth / 2) - padding), y: (labelPoint.y - (textHeight / 2) - padding), width: textWidth + (padding * 2), height: textHeight + (padding * 1.5) };

                base._canvasLayers[3].context.fillRect(geometry.label.rect.x, geometry.label.rect.y, geometry.label.rect.width, geometry.label.rect.height);

                base._canvasLayers[3].context.fillStyle = fillStyle;
                base._canvasLayers[3].context.fillText(text, labelPoint.x, labelPoint.y);

                base._canvasLayers[3].context.restore();
            }        
        };

        // Clear layers that we're drawing on.
        base._canvasLayers[1].context.clearRect(0, 0, base._canvasLayers[1].canvas.width, base._canvasLayers[1].canvas.height);
        base._canvasLayers[3].context.clearRect(0, 0, base._canvasLayers[3].canvas.width, base._canvasLayers[3].canvas.height);

        // Draw outside animation — t = 1 means "fully resolved" state.
        if (!timestamp) {
            for (var i = 0; i < base._figures.length; i++) {
                drawFigure(base._figures[i], 1);
            }
            return;
        }

        // When animation
        if (!base._startAnimation) {
            window.requestAnimationFrame((timestamp) => {
                base.draw(timestamp);
            });
            return;
        }

        if (!base._animationBeginTimestamp) {
            base._animationBeginTimestamp = timestamp;
        }

        const elapsed = timestamp - base._animationBeginTimestamp;

        // Progress from 0 -> 1 over exactly ANIMATION_DURATION ms, eased.
        const rawT = Math.min(elapsed / ANIMATION_DURATION, 1);
        const t = easeOutCubic(rawT);

        for (var i = 0; i < base._figures.length; i++) {
            drawFigure(base._figures[i], t);
        }

        if (rawT < 1) {
            window.requestAnimationFrame((timestamp) => {
                base.draw(timestamp);
            });
        } else {
            // Animation finished — clear cached start values so the next time
            // an animation is kicked off, it snapshots fresh starting positions.
            for (var i = 0; i < base._figures.length; i++) {
                base._figures[i].geometries.forEach((g) => {
                    delete g._startY;
                });
            }
            base._animationBeginTimestamp = null;
        }        
    }

    init() {
        const base = this;

        const canvasWrapper = base._element.querySelector('#fundraiser-visualization');
        if (!canvasWrapper)
            return;

        base._data = JSON.parse(canvasWrapper.getAttribute('data'));
        canvasWrapper.removeAttribute('data')

        base._canvasLayers = [
            {
                canvas: canvasWrapper.querySelector('#fundraiser-visualization-layer0'),
                context: canvasWrapper.querySelector('#fundraiser-visualization-layer0').getContext("2d")
            },
            {
                canvas: canvasWrapper.querySelector('#fundraiser-visualization-layer1'),
                context: canvasWrapper.querySelector('#fundraiser-visualization-layer1').getContext("2d")
            },
            {
                canvas: canvasWrapper.querySelector('#fundraiser-visualization-layer2'),
                context: canvasWrapper.querySelector('#fundraiser-visualization-layer2').getContext("2d")
            },
            {
                canvas: canvasWrapper.querySelector('#fundraiser-visualization-layer3'),
                context: canvasWrapper.querySelector('#fundraiser-visualization-layer3').getContext("2d")
            }
        ];
                
        const prepareGeometries = function(group) {

            const repositionGeometry = function(geometry) { 
                geometry.point1.x *= base._resizeFactor;
                geometry.point1.y *= base._resizeFactor;
                geometry.point2.x *= base._resizeFactor;
                geometry.point2.y *= base._resizeFactor;
                geometry.point3.x *= base._resizeFactor;
                geometry.point3.y *= base._resizeFactor;
            };

            const resizeGeometry = function(geometry, percent, offset) {
                if (percent === 0) return geometry;

                const height =  geometry.point2.y - geometry.point1.y - offset;
                const length = (percent / 100) * height;

                geometry.point3.y -= length;            
                geometry.label.value = percent;
            };

            if (!group.visualizationFigureId)
                return;

            const figure = base._figures.find((item) => { return item.figureId === group.visualizationFigureId; });
            if (!figure)
                return;

            figure.fillColor = group.color;

            // Move and resize all the figures
            for (var i = 0; i < figure.geometries.length; i++) {
                repositionGeometry(figure.geometries[i]);
                resizeGeometry(figure.geometries[i], group.raisedPercent, (figure.geometries[i].offset * base._resizeFactor));
            }
        };
        
        const imageLoader = function(images, loader, done) {            
            var count = images.length;
            
            var completed = function (images, i) {
                count--;
                if (count === 0) {
                    done(images);
                }
            };

            for (var i = 0; i < images.length; i++) {            
                loader(images, i, completed);
            }
        };

        const background = new Image();        
        background.src = base._data.visualizationBackgroundImageUrl;        

        const overlay = new Image();
        overlay.src = base._data.visualizationOverlayImageUrl;

        imageLoader([background, overlay], (images, i, onComplete) => {

            const onLoad = function (e) {
                e.target.removeEventListener("load", onLoad);
                onComplete(images, i);
            }

            images[i].addEventListener("load", onLoad, false);

        }, (images) => {
            
            const imgWidth = background.naturalWidth;
            const imgHeight = background.naturalHeight;

            const aspectRatio = imgWidth / imgHeight;

            const canvasWidth = base._canvasLayers[0].canvas.clientWidth;
            const canvasHeight = canvasWidth / aspectRatio;

            // Set wrapper and all "layers" to same size
            canvasWrapper.style.width = canvasWidth + 'px';
            canvasWrapper.style.height = canvasHeight + 'px';
            for (var i = 0; i < base._canvasLayers.length; i++) {
                base._canvasLayers[i].canvas.width = canvasWidth;
                base._canvasLayers[i].canvas.height = canvasHeight;
            }

            base._resizeFactor = canvasWidth / imgWidth;

            // Fill layer 0 with background image
            base._canvasLayers[0].context.drawImage(background, 0, 0, canvasWidth, canvasHeight);        

            // Prepare data for layer 1 (and 3) and init animation of those layers
            for (var i = 0; i < base._data.groups.length; i++) {
                prepareGeometries(base._data.groups[i]);
                base._startAnimation = true;                
            }

            // Fill layer 2 with overlay image
            base._canvasLayers[2].context.drawImage(overlay, 0, 0, canvasWidth, canvasHeight);
        });

        const mousePositionPoint = function(event) {
            const rectBounds = base._canvasLayers[3].canvas.getBoundingClientRect();
            return { x: event.clientX - rectBounds.left, y: event.clientY - rectBounds.top };
        };

        const currentFigure = function(point) {
            let figure = null;
            for (var i = 0; i < base._figures.length; i++) {
                let geometry = base._figures[i].geometries.find((item) => {
                    return (point.x >= item.point1.x && 
                             point.x <= item.point2.x && 
                             point.y >= item.point1.y && 
                             point.y <= item.point2.y) ||
                             (item.label.rect && 
                             point.x >= item.label.rect.x && 
                             point.x <= (item.label.rect.x + item.label.rect.width) && 
                             point.y >= item.label.rect.y && 
                             point.y <= (item.label.rect.y + item.label.rect.height));
                });
                                
                if (!geometry) continue;

                figure = base._figures[i];
                break;
            }

            return figure;
        };

        const currentGroup = function(point) {
            const figure = currentFigure(point);
            return figure ? base._data.groups.find((item) => { return item.visualizationFigureId === figure.figureId; }) : null;
        };

        base._canvasLayers[3].canvas.addEventListener('mousemove', (event) => {

            for (var i = 0; i < base._figures.length; i++) {
                base._figures[i].active = false;
            }

            const figure = currentFigure(mousePositionPoint(event));
            if (figure) {
                base._canvasLayers[3].canvas.style.cursor = 'pointer';
                figure.active = true;                
            } else {
                base._canvasLayers[3].canvas.style.cursor = 'default';            
            }

            base.draw();            
        });

        base._canvasLayers[3].canvas.addEventListener('click', (event) => {
            const group = currentGroup(mousePositionPoint(event));
            if (!group) return;

            window.location.href = group.detailsPageUrl;
        });

        window.requestAnimationFrame((timestamp) => {
            base.draw(timestamp);
        });
    }
}